// extracted by mini-css-extract-plugin
module.exports = {"cont":"BizCategoryBreadCrumbs_cont__6Tvmv","item":"BizCategoryBreadCrumbs_item__izkkO"};